import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"
import { cn } from "@/lib/utils"
import { isValid } from "date-fns"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

interface DatePickerProps {
  selected?: Date
  onChange: (date: Date | undefined) => void
  placeholder?: string
  className?: string
  minDate?: Date
  disabled?: boolean
}

export function DatePicker({
  selected,
  onChange,
  placeholder = "Pick a date",
  className,
  minDate,
  disabled = false
}: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-full justify-start text-left font-normal",
            !selected && "text-muted-foreground",
            className
          )}
          disabled={disabled}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {selected && isValid(selected) ? format(selected, "PPP") : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(date) => {
            if (date && isValid(date)) {
              onChange?.(date);
            }
          }}
          initialFocus
          disabled={(date) => {
            const checkDate = minDate || new Date();
            checkDate.setHours(0, 0, 0, 0);
            return date < checkDate;
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
